<template>
  <div :class="['select-wrap', { 'add-margin-right': addMargin }]">
    <div
      :class="['postion-wrap', { 'special-style': isSpecial }]"
      @click.stop="showPickerHandler"
    >
      <span class="name">{{ isString ? value : value[1] }}</span>
      <img
        src="https://staff.chunyu.mobi/@/media/images/2022/07/05/d996/d63980eecf2c_w18_h15_.png"
        alt=""
        :class="['select-icon', { cur: showPicker }]"
      />
    </div>
    <van-popup
      v-model="showPicker"
      round
      position="bottom"
      :lazy-render="false"
    >
      <van-picker
        ref="picker"
        show-toolbar
        :columns="columns"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'Select',
  props: {
    columns: {
      type: Array,
      default: () => [],
    },
    value: {
      type: [Array, String],
      default: () => [],
    },
    addMargin: {
      type: Boolean,
      default: false,
    },
    isSpecial: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showPicker: false,
    };
  },
  computed: {
    isString() {
      return typeof this.value === 'string';
    },
  },
  watch: {
    showPicker: {
      handler(newVal) {
        if (!newVal) {
          return;
        }
        // picker打开,默认选中已选择的那一栏
        this.$nextTick(() => {
          if (this.columns != null && this.columns.length > 0) {
            const pickerDom = this.$refs.picker;
            if (this.isString) {
              pickerDom.setColumnValue(0, this.value);
            } else {
              pickerDom.setColumnValue(0, this.value[0]);
              pickerDom.setColumnValue(1, this.value[1]);
            }
          }
        });
      },
      immediate: true,
    },
  },
  methods: {
    // 是否展示picker筛选器，
    showPickerHandler() {
      if (this.columns.length) {
        this.showPicker = true;
      }
    },
    onConfirm(value) {
      console.log('value', value);
      this.$emit('input', value);
      if (this.isString) {
        this.$emit('select', { hasStock: value });
      } else {
        this.$emit('select', { provice: value[0], city: value[1] });
        if (value[0] && value[1]) {
          sessionStorage.setItem(
            'USER_LOCATION',
            JSON.stringify([value[0], value[1]])
          );
        }
      }
      this.showPicker = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@@/styles/mixin.scss';
.select-wrap {
  &.add-margin-right {
    margin-right: rem(25);
  }
  .postion-wrap {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: rem(10) 0;
    font-weight: bold;
    line-height: rem(15);
    text-align: left;
    background: transparent;
  }
  .special-style {
    padding: rem(15) rem(5) rem(10);
  }
  .select-icon {
    width: rem(6);
    height: rem(5);
    margin-left: rem(4);
  }
  .cur {
    transform: rotateZ(180deg);
  }
  ::v-deep .van-picker__cancel {
    font-size: rem(16);
  }
  ::v-deep .van-picker__confirm {
    color: #6ed37c;
    font-size: rem(16);
  }
}
</style>
